/**
 * #2004 居住地 (任意・自己申告)。定義はサーバが正 — services/pay/api/services/municipalities.py。
 * 県と市は**必ず 2 つ一組**で扱う (片方だけの値は保存できない)。
 */
export interface Residence {
  prefecture: string
  city: string
}

export const EMPTY_RESIDENCE: Residence = { prefecture: '', city: '' }

/** 県と市が揃っているか (= 保存できる値か)。 */
export const isCompleteResidence = (r: Residence): boolean => !!r.prefecture && !!r.city

/** 居住地を聞く相手か。訪日客に日本の居住地を聞いても意味が無いので、国籍が日本の人にだけ出す。 */
export const asksResidence = (nationality?: string | null): boolean => nationality === 'JP'
